module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hr-workbench-page"
  }, [_c('div', {
    staticClass: "dash-header"
  }, [_c('div', {
    staticClass: "dash-header-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dash-meta"
  }, _vm._l((_vm.metaRows), function(item) {
    return _c('div', {
      key: item.label,
      staticClass: "dash-meta-row"
    }, [_c('span', {
      staticClass: "dash-meta-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "dash-meta-value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dash-chips"
  }, _vm._l((_vm.chips), function(chip) {
    return _c('span', {
      key: chip.label,
      staticClass: "dash-chip"
    }, [_c('i', {
      staticClass: "chip-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "chip-label"
    }, [_vm._v(_vm._s(chip.label))]), _vm._v(" "), _c('span', {
      staticClass: "chip-value"
    }, [_vm._v(_vm._s(chip.value))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "section-adviser"
  }, [_c('span', {
    staticClass: "section-adviser-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('adviser-select', {
    on: {
      "on-change": _vm.onAdviserChange,
      "on-loaded": function($event) {
        _vm.advisers = $event
      }
    },
    model: {
      value: (_vm.adviserId),
      callback: function($$v) {
        _vm.adviserId = $$v
      },
      expression: "adviserId"
    }
  })], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.kpiCards), function(card) {
    return _c('article', {
      key: card.key,
      staticClass: "kpi-card is-clickable",
      class: 'is-' + card.level,
      on: {
        "click": function($event) {
          return _vm.goCard(card)
        }
      }
    }, [_c('div', {
      staticClass: "kpi-bar"
    }), _vm._v(" "), _c('div', {
      staticClass: "kpi-body"
    }, [_c('div', {
      staticClass: "kpi-title"
    }, [_c('i', {
      staticClass: "kpi-dot"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(card.title))])]), _vm._v(" "), _c('div', {
      staticClass: "kpi-value"
    }, [_vm._v(_vm._s(card.value))]), _vm._v(" "), _c('div', {
      staticClass: "kpi-period-row"
    }, [_c('span', {
      staticClass: "kpi-period"
    }, [_vm._v(_vm._s(card.period))]), _vm._v(" "), (card.compare) ? _c('span', {
      staticClass: "kpi-compare",
      class: 'is-' + card.compareTone
    }, [_vm._v(_vm._s(card.compare))]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "kpi-foot"
    }, [_vm._v(_vm._s(card.foot))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section dash-two-col"
  }, [_c('div', {
    staticClass: "dash-block"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("今日待办")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "block-note"
  }, [_vm._v(_vm._s(_vm.todayStr) + " · 共 " + _vm._s(_vm.todos.length) + " 项" + _vm._s(_vm.todos.length > 16 ? '，显示前 16 项' : ''))])]), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("试用期、合同、昨日出勤待跟进、新外教回访、异动高危，按紧急 → 关注 → 预告排序。")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(!_vm.shownTodos.length) ? _c('div', {
    staticClass: "todo-empty"
  }, [_c('div', {
    staticClass: "todo-empty-big"
  }, [_vm._v("今日暂无待办")]), _vm._v(" "), _c('div', [_vm._v("所有提醒均已处理完毕")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shownTodos), function(t, idx) {
    return _c('div', {
      key: t.kind + '-' + t.tchId + '-' + idx,
      staticClass: "todo-row"
    }, [_c('span', {
      staticClass: "todo-bar",
      class: 'is-' + (t.severity || 'info')
    }), _vm._v(" "), _c('div', {
      staticClass: "todo-main"
    }, [_c('div', {
      staticClass: "todo-title"
    }, [_c('span', {
      staticClass: "tch-name-row"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(t.tchId)
        }
      }
    }, [_vm._v(_vm._s(t.title || _vm.tchText(t)))]), _vm._v(" "), (_vm.scoreText(t)) ? _c('span', {
      staticClass: "tch-score-badge"
    }, [_vm._v(_vm._s(_vm.scoreText(t)))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "todo-kind",
      class: 'is-' + (t.severity || 'info')
    }, [_vm._v(_vm._s(_vm.kindText(t.kind)))])]), _vm._v(" "), _c('div', {
      staticClass: "todo-meta"
    }, [_vm._v(_vm._s(t.meta))]), _vm._v(" "), (t.action) ? _c('div', {
      staticClass: "todo-action"
    }, [_vm._v("建议：" + _vm._s(t.action))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "todo-btns"
    }, [_c('Button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(t.tchId)
        }
      }
    }, [_vm._v("档案")]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "type": "primary",
        "loading": _vm.todoLoadingKey === _vm.todoKey(t)
      },
      on: {
        "click": function($event) {
          return _vm.handleTodo(t)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.kindButton(t.kind)) + "\n            ")])], 1)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-block"
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("每天请假 + 旷课（含失联）课节数，含今天。")]), _vm._v(" "), _c('div', {
    staticClass: "card trend-card"
  }, [_c('div', {
    staticClass: "trend"
  }, _vm._l((_vm.trendBars), function(d) {
    return _c('div', {
      key: d.date,
      staticClass: "trend-col"
    }, [_c('span', {
      staticClass: "trend-num"
    }, [_vm._v(_vm._s(d.count))]), _vm._v(" "), _c('div', {
      staticClass: "trend-bar",
      class: {
        'is-yesterday': d.isYesterday
      },
      style: ({
        height: d.height + 'px'
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "trend-label"
    }, [_vm._v(_vm._s(d.label))])])
  }), 0)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, _vm._l((_vm.probationBars), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "dist-row"
    }, [_c('div', {
      staticClass: "dist-head"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.value) + " 人")])]), _vm._v(" "), _c('div', {
      staticClass: "dist-track"
    }, [_c('div', {
      staticClass: "dist-fill",
      class: 'is-' + item.tone,
      style: ({
        width: item.percent + '%'
      })
    })])])
  }), 0), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, _vm._l((_vm.contractBars), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "dist-row"
    }, [_c('div', {
      staticClass: "dist-head"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.value) + " 人")])]), _vm._v(" "), _c('div', {
      staticClass: "dist-track"
    }, [_c('div', {
      staticClass: "dist-fill",
      class: 'is-' + item.tone,
      style: ({
        width: item.percent + '%'
      })
    })])])
  }), 0)])]), _vm._v(" "), _c('probation-decide-modal', {
    attrs: {
      "value": _vm.modal.probation,
      "row": _vm.modalRow
    },
    on: {
      "on-close": function($event) {
        _vm.modal.probation = false
      },
      "on-success": _vm.loadSummary
    }
  }), _vm._v(" "), _c('review-save-modal', {
    attrs: {
      "value": _vm.modal.review,
      "row": _vm.modalRow
    },
    on: {
      "on-close": function($event) {
        _vm.modal.review = false
      },
      "on-success": _vm.loadSummary
    }
  }), _vm._v(" "), _c('contract-renew-modal', {
    attrs: {
      "value": _vm.modal.contract,
      "row": _vm.modalRow
    },
    on: {
      "on-close": function($event) {
        _vm.modal.contract = false
      },
      "on-success": _vm.loadSummary
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-header-left"
  }, [_c('h1', {
    staticClass: "dash-title"
  }, [_vm._v("外管工作台")]), _vm._v(" "), _c('p', {
    staticClass: "dash-sub"
  }, [_vm._v("Foreign Teacher HR Workbench / 试用期 / 新外教回访 / 合同续签 / 出勤跟进 / 异动高危")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-filters"
  }, [_c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("健康")]), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("需关注")]), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("预警")]), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 口径：在职外教（在职 + 外教），按服务器当日自然日计算 · 点击卡片进入对应页面")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("紧急\n          / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("关注\n          / "), _c('i', {
    staticClass: "legend-dot is-info"
  }), _vm._v("预告\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("近 7 日异动趋势")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head block-gap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("试用期状态分布")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head block-gap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("合同状态分布")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe27a288","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrWorkbench/HrWorkbenchDashboard.vue
// module id = 1989
// module chunks = 8